// src/utils/recurrence.js — canonical recurrence date stepper for recurring job rules.
// Shared so admin recurrence UIs (AssignJobsTab, RecurringRulesTab) can't drift apart.
export function getNextDate(dateStr, frequency) {
  // Parse YYYY-MM-DD explicitly and operate in UTC to avoid timezone shifts
  const [yy, mm, dd] = String(dateStr).split("-").map(Number);
  if (!yy || !mm || !dd) return "";

  const dt = new Date(Date.UTC(yy, mm - 1, dd));

  switch (frequency) {
    case "daily":
      dt.setUTCDate(dt.getUTCDate() + 1);
      break;

    case "weekly":
      dt.setUTCDate(dt.getUTCDate() + 7);
      break;

    case "fortnightly":
      dt.setUTCDate(dt.getUTCDate() + 14);
      break;

    case "monthly": {
      const originalDay = dt.getUTCDate();
      dt.setUTCMonth(dt.getUTCMonth() + 1);

      // Handle month rollover (e.g., Jan 31 -> Feb end)
      if (dt.getUTCDate() < originalDay) {
        dt.setUTCDate(0); // last day of the intended month
      }
      break;
    }

    default:
      return "";
  }

  // Safe because dt is UTC
  return dt.toISOString().slice(0, 10);
}
